import i18n from '../i18n';
import { GAME_TITLE } from './GameTitle';

export enum PRIZE_STEP {
    STEP1 = 1,
    STEP2 = 2,
    STEP3 = 3,
    STEP4 = 4
}
export const PrizeSteps = [
    {
        label: i18n.t('epic.esport.step1.title'),
        value: PRIZE_STEP.STEP1
    },
    {
        label: i18n.t('epic.esport.step2.title'),
        value: PRIZE_STEP.STEP2
    },
    {
        label: i18n.t('epic.esport.step3.title'),
        value: PRIZE_STEP.STEP3
    },
    {
        label: i18n.t('epic.esport.step4.title'),
        value: PRIZE_STEP.STEP4
    }
];

export const PrizeStepsForPG = [
    {
        label: i18n.t('epic.esport.step1.title'),
        value: PRIZE_STEP.STEP1
    },
    {
        label: i18n.t('epic.esport.step2.title'),
        value: PRIZE_STEP.STEP2
    },
    {
        label: i18n.t('epic.esport.step3.title'),
        value: PRIZE_STEP.STEP3
    }
];

export enum TabValue {
    PRIZES = 'PRIZES',
    TAX = 'TAX'
}

export interface TabComponentProps {
    onTabChange?: (tab: TabValue) => void;
}

export const GAME_GATED_USER_AGE: Record<string, number> = {
    [GAME_TITLE.FORTNITE]: 13,
    [GAME_TITLE.FALL_GUYS]: 13,
    [GAME_TITLE.ROCKET_LEAGUE]: 13,
    [GAME_TITLE.SIDE_SWIPE]: 15
};
